import React from 'react';
import { Store } from 'pullstate';
import FallbackSpinner from '../../materio/@core/components/spinner';
import { client } from '../../utils/axios-client';
import { SelectOption } from '../../types/common';



const OptionsStore = new Store({
    countries: [] as SelectOption[],
    stages: [] as SelectOption[],
    levels: [] as SelectOption[],
    functions: [] as SelectOption[],
    regions: [] as SelectOption[],
    owners: [] as SelectOption[],
    sources: [] as SelectOption[],
    industries: [] as SelectOption[],
    employeeSizes: [] as SelectOption[],
    customers: [] as SelectOption[],
    templateTypes: [] as SelectOption[]
})

type Props = {
    children: React.ReactNode
}

export const loadOption = async (optionType: string): Promise<SelectOption[]> => {
    const response = await client.get<SelectOption[]>(`/api/options/${optionType}`);
    return response.data;
}

export const loadOptionForCustomer = async (optionType: string, customerId: string): Promise<SelectOption[]> => {
    const response = await client.get<SelectOption[]>(`/api/options/${customerId}/${optionType}`);
    return response.data;
}

export const loadOptionsForSprint = async (sprintId: string): Promise<SelectOption[]> => {
    const response = await client.get<SelectOption[]>(`/api/options/sprints/${sprintId}/cadences`);
    return response.data;
}

const OptionsLoader = ({ children }: Props) => {
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        loadOptions();
    }, [])

    const loadOptions = async () => {
        loadOption('country').then(options => OptionsStore.update(s => { s.countries = options }));
        loadOption('region').then(options => OptionsStore.update(s => { s.regions = options }));
        loadOption('owner').then(options => OptionsStore.update(s => { s.owners = options }));
        loadOption('stage').then(options => OptionsStore.update(s => { s.stages = options }));
        loadOption('source').then(options => OptionsStore.update(s => { s.sources = options }));
        loadOption('level').then(options => OptionsStore.update(s => { s.levels = options }));
        loadOption('industry').then(options => OptionsStore.update(s => { s.industries = options }));
        loadOption('employeesize').then(options => OptionsStore.update(s => { s.employeeSizes = options }));
        loadOption('function').then(options => OptionsStore.update(s => { s.functions = options }));
        loadOption('customers').then(options => OptionsStore.update(s => { s.customers = options }));
        setLoading(false);
    }

    if (loading) return <FallbackSpinner />

    return <>{children}</>
}

export { OptionsLoader, OptionsStore }
export default OptionsLoader;